import { render, staticRenderFns } from "./VueTypeaheadBootstrap.vue?vue&type=template&id=13e97235&scoped=true"
import script from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js"
export * from "./VueTypeaheadBootstrap.vue?vue&type=script&lang=js"
import style0 from "./VueTypeaheadBootstrap.vue?vue&type=style&index=0&id=13e97235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e97235",
  null
  
)

export default component.exports